"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = schemaTreeGenerate;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _lodash = require("lodash");
var _constant = require("./constant");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
   * 对应数据树的schema树的生成，uicore渲染表单要用
   * @param {*} table
   */
function schemaTreeGenerate(table) {
  var curSchema = (0, _lodash.cloneDeep)(table.schemaList);
  if (table.forkTableList.length > 0) {
    table.forkTableList.forEach(function (forkTableObj) {
      var ratio = forkTableObj.relationObj.ratio,
        forkTable = forkTableObj.forkTable;
      var forkSchema = schemaTreeGenerate(forkTable);
      if (ratio === 1) {
        // 1对1关系
        var field = _objectSpread(_objectSpread({}, forkSchema), {}, {
          id: "".concat(_constant.TABLETAG).concat(forkTable.tableKey)
        });
        curSchema.fields.push(field);
      } else {
        var _field = {
          // 1对多关系
          id: "".concat(_constant.TABLETAG).concat(forkTable.tableKey),
          type: 'array',
          items: forkSchema
        };
        curSchema.fields.push(_field);
      }
    });
  }
  return curSchema;
}